import React from "react";
import { useNavigate } from "react-router-dom";
import PlansCard from "../../../components/plansCard/PlansCard";
import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import Notification from "../../../components/Notification/Notification";

const ManageSubscription = () => {
  const navigate = useNavigate();

  const goBack = () => {
    navigate(-1);
  };

  return (
    <>
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h3
              className="ah-heading-04 fw-bold me-29 mb-0 d-flex align-items-center gap-3 cursor-pointer"
              onClick={goBack}
            >
              <span aria-label="Back">
                <span className="icon-arrow-left"></span>
              </span>
              Manage Subscription
            </h3>
          </div>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <Notification />
          </div>
        </div>
      </div>
      <div className="manage-subscription-content">
        <PlansCard />
      </div>
    </>
  );
};

export default ManageSubscription;
